import { render, staticRenderFns } from "./analyse.vue?vue&type=template&id=2c950223&scoped=true"
import script from "./analyse.vue?vue&type=script&lang=js"
export * from "./analyse.vue?vue&type=script&lang=js"
import style0 from "./analyse.vue?vue&type=style&index=0&id=2c950223&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c950223",
  null
  
)

export default component.exports